export interface SwitchConfig {
  label: string;
  value: number | string;
  checked: boolean;
  disabled?: boolean;
  disabledTooltipText?: string;
}

export enum LabelSwitchEvents {
  CHANGE = 'labelSwitchChanged',
}
